import React, { useMemo, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";
import { PRODUCTS } from "../data/products";

const Collections = () => {
  const { category } = useParams();
  const [searchParams] = useSearchParams();
  const q = (searchParams.get("q") || "").toLowerCase();
  const [filter, setFilter] = useState(category || "all");

  const products = useMemo(() => {
    let list = PRODUCTS;
    const f = category || filter;
    if (f && f !== "all") list = list.filter((p) => p.category === f);
    if (q) list = list.filter((p) => `${p.name} ${p.color}`.toLowerCase().includes(q));
    return list;
  }, [category, filter, q]);

  return (
    <>
      <SEO title="Collections" description="All hoodies and tees from The Dripchexk. Heavyweight, oversized, statement pieces from ₹799." />
      <section className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 pt-12 pb-6">
        <p className="tiny-link text-[#FF69B4]">Shop</p>
        <h1 className="font-display text-5xl sm:text-7xl mt-3 tracking-[0.03em]">
          COLLECTIONS<span className="text-[#FF69B4]">.</span>
        </h1>
        <p className="text-white/50 mt-4 max-w-xl text-sm">
          {products.length} pieces · Free shipping on orders above ₹1,999 · COD available.
        </p>

        <div className="flex gap-3 mt-8 border-b border-[#222]">
          {[
            { key: "all", label: "All" },
            { key: "hoodies", label: "Hoodies" },
            { key: "tees", label: "Tees" },
          ].map((t) => (
            <Link
              to={t.key === "all" ? "/collections" : `/collections/${t.key}`}
              key={t.key}
              onClick={() => setFilter(t.key)}
              data-testid={`filter-${t.key}`}
              className={`tiny-link py-3 px-4 border-b-2 -mb-px transition-colors ${
                (category || filter) === t.key
                  ? "border-[#FF69B4] text-white"
                  : "border-transparent text-white/50 hover:text-[#FF69B4]"
              }`}
            >
              {t.label}
            </Link>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-5 sm:px-8 lg:px-12 pb-24">
        <motion.div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
          {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
        </motion.div>
        {products.length === 0 && (
          <p className="text-center text-white/50 py-20" data-testid="empty-collection">No pieces match your search.</p>
        )}
      </section>
    </>
  );
};

export default Collections;
